module.exports = __webpack_public_path__ + "img/loading.cc76f15a.gif";